<template>
  <Fragment>
    <!-- creation time -->
    <td class="order__info-data">
      <div>{{ formattedDate(order.created_at) }}</div>
      <div>{{ formattedTime(order.created_at) }}</div>
    </td>

    <!-- order status -->
    <td class="order__info-data order__status">
      <span :class="[order.status, isInvoiced ? 'invoiced' : '']">{{ translatedStatus }}</span>
    </td>

    <!-- order type -->
    <td class="order__info-data">
      {{ order.human_type }}
      <span
        v-if="order.hasCommentActionImage"
        class="material-icons order__info-data-icon"
        :title="$t('orders.orderWithCommentActionImage')"
      >
        error
      </span>
    </td>

    <!-- full container info -->
    <td class="order__info-data order__info-data__wide">
      <OrdersTableDetailsCell :order="order" />
    </td>

    <!-- location info -->
    <td class="order__info-data">
      <div class="order__info-data-content">
        <span>
          {{ order.area_name || '–' }}
        </span>
        <span>
          {{ (order.origin_zone && order.origin_zone.name) || '–' }}
        </span>
      </div>
    </td>

    <!-- user actions -->
    <td class="order__info-data">
      <button @click="showOrderModal(order.uuid)" class="order__action-button">
        <span v-if="order.status === 'closed'" class="material-icons">search</span>
        <span v-else class="material-icons">edit</span>
      </button>
    </td>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import OrdersTableDetailsCell from '@/components/Orders/OrdersTable/OrdersTableRow/OrdersTableDetailsCell'
import dateUtils from '@/components/mixins/dateUtils'
import stringUtils from '@/components/mixins/stringUtils'

import { ORDER_TYPE } from '@/api/orders'

export default {
  name: 'OrdersTableRow',
  mixins: [dateUtils, stringUtils],
  components: { Fragment, OrdersTableDetailsCell },
  props: {
    order: { type: Object },
  },
  methods: {
    async showOrderModal(orderUuid) {
      this.$router.push({
        path: `/orders/${orderUuid}`,
        query: this.$router.currentRoute.query,
      })
    },
  },
  computed: {
    isInvoiced() {
      return this.order.billing && this.order.billing.invoice_status == 'invoiced'
    },
    translatedStatus() {
      if (this.isInvoiced) return this.$t('orders.statusInvoiced')
      return this.$t(`orders.status${this.capitalize(this.order.status)}`)
    },
  },
  created() {
    this.ORDER_TYPE = ORDER_TYPE
  },
}
</script>

<style lang="scss" src="./OrdersTableRow.scss" scoped />
